
const mutations = {
    
    projectMutation(state, payload) {
        state.projectData = Array.isArray(payload.result) ? [...payload.result] : [];
        //console.log("fetchproject :2Project mutation with payload ", payload)
        const rolesMap = {}
        if (Array.isArray(payload.roles)) {
            payload.roles.forEach(roleObj => {
                rolesMap[roleObj.project] = roleObj.roles
            })
        }
        const referentialMap = {}
        if (Array.isArray(payload.referentials)) {
            payload.referentials.forEach(refObj => {
                referentialMap[refObj.project] =  { 
                    name: refObj.name,
                    status: refObj.status,
                }
            })
        }
        const shareMap = {}
        if (Array.isArray(payload.shares)) {
            payload.shares.forEach(shareObj => {
                shareMap[shareObj.project] = { 
                    is_shared : shareObj.is_shared? shareObj.is_shared : false,
                    is_owner  : shareObj.is_owner? shareObj.is_owner : false,
                    has_evaluator : shareObj.has_evaluator? shareObj.has_evaluator : false
                }
            })
        }
        state.projectData.forEach(project => {
            const roles = rolesMap[project.project_id] || []
            project.PC = roles.includes("PC")
            project.PE = roles.includes("PE")
            const collapsedProjects = JSON.parse(localStorage.getItem('collapsedProjects') || '{}');
            project.collapsed = collapsedProjects[project.project_id] === true || false
            const referential = referentialMap[project.project_id] || {};
            //console.log("fetchproject : collapsedProjects : ",collapsedProjects,"\nproject :", project)
            project.referential_name = referential?.name || "";
            project.referential_status = referential?.status || "";
            project.is_shared = shareMap[project.project_id] ? shareMap[project.project_id].is_shared : false
            project.is_owner = shareMap[project.project_id] ? shareMap[project.project_id].is_owner : false
            project.has_evaluator = shareMap[project.project_id] ? shareMap[project.project_id].has_evaluator : false
        })
        //console.log("fetchProject :state value", state.projectData)
    },
    projectUniqueMutation(state, payload){
        state.projectValues = payload;
        //console.log("fetchproject :projectUniqueMutation with payload ", payload)
    },
    answerMutation(state, payload) {
        state.answerQ = payload.result ? payload.result : []
        /* //console.log("state value", state.answerQ) */
    },
    answerMutationTest(state, payload) {
        state.answerQTest = payload.result ? Object.values(payload.result) : []
        /* //console.log("state value", state.answerQ) */
    },
    evaluationCriteriaMutation(state, payload) {
        state.evaluationCriteriaColor = payload.result ? payload.result : {}
    },
    evaluationQuestionMutation(state, payload) {
        state.evaluationQColor = payload.result ? payload.result : {}
    },
    updateAnswerMutation(state, payload) {
        //console.log("Payload received:", payload);
        //console.log("Current answerQTest state:", state.answerQTest);
        if(!payload)return;
        if (Array.isArray(payload)) {
            state.answerQTest = payload;
        } 
        else if (typeof payload === 'object') {
            state.answerQTest = Object.values(payload).filter(item => {
                return item && typeof item === 'object' && (item.question_id !== undefined || item.answer_color !== undefined);
            });
        } else {
            state.answerQTest = [];
        }
        /* const answerIndex = state.answerQTest.findIndex(answer => answer.question_id === payload.question_id);
        //console.log("Index found:", answerIndex);
        if (answerIndex > -1) {
            //console.log(`Updating existing answer for question ${payload.question_id}`);
            const updatedAnswer = {  ...state.answerQTest[answerIndex],
                answer_value: payload.user_value ?? state.answerQTest[answerIndex].answer_value,
                answer_color: payload.user_color ?? state.answerQTest[answerIndex].answer_color,
                comment: payload.comment ?? state.answerQTest[answerIndex].comment
                };
                state.answerQTest.splice(answerIndex, 1, updatedAnswer);
            //console.log("that's where the trouble is :", state.answerQTest)
    
        } else {
            //console.log(`Creating new answer for question ${payload.question_id}`);
            const newAnswer = {
                question_id: payload.question_id,
                //user_result: payload.user_result,
                user_value: payload.calculated,
                user_color: payload.color,
                comment: payload.comment, 
            };
            state.answerQTest.push(newAnswer);
        } */
    },
    updateProjectMutation(state, payload) {
        //console.log("Update project mutation with payload ", payload)
        const projectIndex = state.projectData.findIndex(project => project.project_id === payload.project_id);
        if (projectIndex !== -1) {
            state.projectData[projectIndex] = {
                ...state.projectData[projectIndex],
                ...payload
            };
            //console.log("Updated project:", state.projectData[projectIndex]);
        } else {
            state.answerQTest.push(payload);
            console.warn("Project with project_id not found:", payload.project_id);
        }
    },
    addProjectMutation(state, payload) {
        //console.log("Adding project mutation with payload ", payload)
        const existingProject = state.projectData.find(project => project.project_id === payload.project_id);

        if (!existingProject) {
            state.projectData.push(payload);
            //console.log("New project added:", payload);
        } else {
            console.warn("Project with project_id already exists:", payload.project_id);
        }
    },
    deleteProjectMutation(state, id) {
        //console.log("Deleting project mutation with payload ", id)

        const existingProjectIndex = state.projectData.findIndex(project => project.project_id ===id);
        if (existingProjectIndex !== -1) {
            state.projectData.splice(existingProjectIndex, 1);
            //console.log("Project deleted:", id);
        } else {
            console.warn("Project with project_id not found:", id);
        }
    },
    selectProjectMutation(state, payload) {
        state.selectedProject = parseInt(payload)
        //console.log("Selecting project mutation with payload ", payload)
        if(payload === 0) {
            state.criteriaTree = []  // this generates an issue when creating a new project. should be analyzed later
            state.questionTree = []
            state.generalData = []
            state.answerQTest = []
            state.evaluationCriteriaColor = []
            state.evaluationQColor = []
            state.selectedQuestion = 0
            state.sharecode = []
            state.userList = []
            state.userListRightsProject = []
            state.files = []
            state.file  = []
            state.roles = false
            state.filterBlackQuestionsActive = false
            state.projectErrors = []
            state.criteriaEvaluation = []
            state.tagValues = {}
        }
        /* //console.log("selectedProject :", state.selectedProject) */
    },
    selectQuestionMutation(state, payload) {
        //console.log("selecting question based on project: ", payload)
        state.selectedQuestion = parseInt(payload)
    },
    selectReferentialIDMutation(state, payload) {
        /* //console.log("selecting referential_id based on project: ", payload) */
        state.selectedReferentialId = parseInt(payload)
        //console.log("selectedReferential:", state.selectedReferentialId)
    },
    loadingMutation(state, payload) {
        if(state.loading != payload){
            state.loading = payload
            //console.log("loadingMutation Project => state",state.loading,"\npayload", payload)
        }
    },

    loadTreeMutation(state, payload) {
        ////console.log("Mutation launched with payload", payload);
        state.criteriaTree = Array.isArray(payload)
            ? payload.map(project => ({
                ...project,
                collapsed: false,
            }))
            : [];

        //console.log("state criteriaValue", state.criteriaTree);
    },

    loadTreeQuestionMutation(state, payload) {
        //console.log("Question mutation launched with payload ", payload)
        state.questionTree = Array.isArray(payload) ? [...payload] : []
        //console.log("questionTree mutated", state.questionTree)
    },

   /*  expandAllCriteria(state) {
        if (!state.criteriaTree || state.criteriaTree.length === 0) {
            return;
        }
        state.criteriaTree = state.criteriaTree.map(criteria => ({
            ...criteria,
            collapsed: false
        }));
    }, */
    
    toggleProjectModalNew(state, payload) {
        //console.log("toggleProjectModalNew mutation with payload ", payload)
        state.canEditList.projectModalOpen = payload
    },

    returnConfirmationObjectMutation(state, payload) {
        //console.log("Return confirmation object mutation with payload ", payload)
        state.confirmationObject = payload
        state.canEditList.confirmationDialogOpen = true
    },

    toggleConfirmationDialog(state, payload) {
        state.canEditList.confirmationDialogOpen = payload
    },
    productionReferentialsMutation(state, payload) {
        //console.log("Production referentials mutation with payload ", payload)
        state.productionReferentials = Array.isArray(payload.result) ? [...payload.result] : []
        //console.log("state value", state.productionReferentials)
    },
    collapseProjectMutation(state, projectId) {
        const criteriaIndex = state.criteriaTree.findIndex(criteria => criteria.id === projectId);
        if (criteriaIndex !== -1) {
            const criteria = state.criteriaTree[criteriaIndex];
            state.criteriaTree[criteriaIndex] = {
                ...criteria,
                collapsed: !criteria.collapsed
            };
        }

    },
    collapseReferentialMutation(state, payload) {
        const refId = payload.referential_id;
        const groupItems = state.projectData.filter(item => item.referential_id === refId);
        
        if (groupItems.length === 0) return;

        const targetCollapsed = !groupItems[0].collapsed;
        state.projectData = state.projectData.map(item =>
            item.referential_id === refId ? { ...item, collapsed: targetCollapsed } : item
        );
    },
    generalDataMutation(state, payload) {
        //console.log("General data mutation with payload ", payload)
        // Assuming payload is an object with the general data
        const sorted = Array.isArray(payload) ? payload.sort((a, b) => 
            a.chapter - b.chapter || 
            a.view_order - b.view_order) : [];
        state.generalData = sorted;
        //console.log("Updated general data:", state.generalData);
    },
    updateGeneralDataMutation(state, { tag, value, /* comment, */ index }) {
        //console.log("Update general data mutation with payload ", tag, value,comment, index)
        const firstIndex = state.generalData.findIndex(item => item.tag === tag)
        if (firstIndex === -1) {
            console.error(`Variable with tag ${tag} not found in generalData`)
            return
        }
        //console.log("generalData before update:", firstIndex, state.generalData[firstIndex])
        if(index === -1) {
            state.generalData[firstIndex].value = value;
        } else {
            const count = state.generalData[firstIndex].count
            if ( !Array.isArray(state.generalData[firstIndex].values) || state.generalData[firstIndex].values.length !== count ) {
                // Fill values[] with nulls up to count
                state.generalData[firstIndex].values = Array(count).fill(null);
            }
            state.generalData[firstIndex].values[index] = value;
        }
        // Keep the order after update
        state.generalData.sort((a, b) => a.chapter - b.chapter || a.view_order - b.view_order);
    },
    updateGeneralDataArrayMutation(state, payload) {
        const incoming = Array.isArray(payload) ? [...payload] : [];
        if (state.generalData.length === 0) {
            state.generalData = [...incoming];
            return;
        }

        const currentMap = new Map(state.generalData.map(item => [item.tag, item]));
        const updatedData = [];
        for (const item of incoming) {
            const existing = currentMap.get(item.tag);
            if (!existing) {
                updatedData.push({ ...item });
            } else {
                const hasChanged = Object.keys(item).some(key => item[key] !== existing[key]);
                updatedData.push(hasChanged ? { ...item } : existing);
            }
        }
        updatedData.sort((a, b) => a.chapter - b.chapter || a.view_order - b.view_order);
        state.generalData = updatedData;
    },
    // updateProjectTeamMutation(state, payload) {
    //     //console.log("state value before update", state.projectTeam)
    //     //console.log("Update project team mutation with payload ", payload)
    //     state.projectTeam = Array.isArray(payload) ? [...payload] : []
    //     //console.log("state value", state.projectTeam)
    // },
    shareProjectMutation(state, payload) {
        /* //console.log("selecting question based on project: ", payload) */
        state.sharecode = payload
    },
    userListMutation(state, payload) {
        /* //console.log("User list mutation with payload ", payload) */
        state.userList = Array.isArray(payload.result) ? [...payload.result] : [];
        //console.log("state userList", state.userList);
    },
    userListRightsProjectMutation(state, payload) {
        /* //console.log("User list rights mutation with payload ", payload) */
        state.userListRightsProject = Array.isArray(payload.result) ? [...payload.result] : [];
        //console.log("state userListRightsProject", state.userListRightsProject);
    },
    updateUserAccessMutation(state, { user, type, checked }) {
        //console.log("Updating user access", user, type, checked)
        let search = state.userListRightsProject.find(search => search.user_id === user.user_id)
        if (search) {
            if (type === 'PE') {
                if (checked) {
                    search.roles = search.roles ? search.roles + ",PE" : "PE"
                } else {
                    search.roles = search.roles.replace(/PE/g, "").replace(/,,/g, ",").replace(/^,|,$/g, "")
                }
            }
        }else {
            let roles = "";
            if (checked) {
                roles = type;
            }
            state.userListRightsProject.push({
                user_id: user.user_id,
                roles
            });
           /*  //console.log("Added new user to userListRightsProject:", user.user_id, roles); */
        }
        //console.log("list after update", state.userListRightsProject)
    },
    setAllFilesMutation(state, payload) {
        //console.log("Remplacement de toute la liste des fichiers", payload);
        state.files = (payload && payload.files && Array.isArray(payload.files)) ? [...payload.files] : [];
    },

    addFileMutation(state, payload) {
        //console.log("Ajout/Update d'un fichier", payload);
        const index = state.files.findIndex(f => 
            (f.id && f.id === payload.id) || 
            (f.name === payload.name && f.question_id === payload.question_id)
        );

        if (index !== -1) {
            state.files.splice(index, 1, payload);
        } else {
            state.files.push(payload);
        }
    },
    getFileMutation(state, payload){
        state.file = payload;
        //console.log("image file payload ", state.file);
    },
    projectRightsMutation(state, payload) {
        state.roles = payload
        //console.log("state.roles", state.roles)
    },
    toggleBlackQuestionsFilter(state) {
        state.filterBlackQuestionsActive = !state.filterBlackQuestionsActive
    },
    toggleUnAnsweredQuestionsActive(state){
        state.filterUnAnsweredQuestionsActive = !state.filterUnAnsweredQuestionsActive
    },
    projectValidateMutation(state,payload){
        state.projectErrors = payload;
        //console.log("state.projectErrors", state.projectErrors);
    },
    //TODO CHECK HOW GREAT IS THE CONDITION, I BELIEVE IT'S BROKEN
    setEvaluationLoaded(state, payload) {
        if(state.evaluationLoaded != payload){
            //console.log("Setting evaluation loaded state to", payload)
            state.evaluationLoaded = payload
        }
    },
    setCriteriaEvaluation(state, payload) {
        //console.log("Setting criteria evaluation state with payload", payload.result)
        state.criteriaEvaluation = Array.isArray(payload.result) ? [...payload.result] : []
        //console.log("state.criteriaEvaluation", state.criteriaEvaluation)
    },
    updateEvaluationMutation(state, payload) {
        //console.log("Updating evaluation with payload", payload, "for criteriaId", payload.criteriaId)
        const criteriaIndex = state.criteriaEvaluation.findIndex(criteria => criteria.criteria_id === payload.criteriaId);
        //console.log("criteriaIndex", criteriaIndex)
        const dataCriteria = payload.data.find(criteria => criteria.criteria_id === payload.criteriaId);
        state.criteriaEvaluation[criteriaIndex] = dataCriteria;
        //console.log("dataCriteria", dataCriteria)
    },
    fetchTagValues(state, payload){
        const tag = payload.tag
        const value = payload.data
        //console.log("payload tag",payload)
        ///////////////////////////////////
        // Duplicated key warning here ! //
        
        /* if(payload.data != state.tagValues[tag]){
            //console.log(payload.data + " DUPLICATED " + state.tagValues[tag])
            return;
        } */
        state.tagValues = {
            ...state.tagValues,
            [tag]: value,

        };
    },
    fetchPDF(state, payload){
        //console.log("payload.pdf: ",payload);
        state.pdf = Array.isArray(payload?.reports) ? payload.reports : [];
        /* //console.log("state.pdf: ",state.pdf); */
    },
    createPDFMutation(state, payload){
        state.temPdf = payload;
        ////console.log("State.temPDF ", state.temPdf)
    },
    clearProjectState(state) {
        //console.log("clearProjectState")
        state.projectData = []
        state.criteriaTree = []
        state.questionTree = []
        state.selectedProject = 0
        state.selectedReferentialId = 0
        // state.canEditList = {
        //     projectTitle: true,
        //     projectDescription: true,
        //     projectModalOpen: false,
        //     confirmationDialogOpen: false,
        // }
        state.confirmationObject = []
        // state.loading = false
        state.productionReferentials = []
        state.generalData = []
        state.answerQTest = []
        state.evaluationCriteriaColor =[]
        state.evaluationQColor =[]
        state.selectedQuestion = 0
        state.sharecode = []
        state.userList = []
        state.userListRightsProject = []
        state.files =[]
        state.file  = []
        state.roles =false
        state.filterBlackQuestionsActive = false
        state.projectErrors = []
        state.criteriaEvaluation = []
    },
    setGraphData(state, payload) {
        // //console.log("Setting graph data with payload", payload)
        state.graphData = payload
        // //console.log("state.graphData", state.graphData)
    },
}
export default mutations